import React, { Component } from 'react';
import _ from 'lodash'
import { css } from 'aphrodite';
import { Flexbox } from './Styles'

import Configuration from './models/Configuration';
import Progress from './models/Progress';
import Scoreboard from './Scoreboard';
import ScenarioInfo from './ScenarioInfo';
import Turn from './Turn';
import EventReportCard from './EventReportCard';
import GameOver from './GameOver';
import Winner from './Winner';

import ScrollFix from './ScrollFix';

class Game extends Component {
  constructor(props) {
    super(props);
    this.state = this.newGameState();
  }

  render() {
    if (this.state.pregame) {
      return(
        <div className={css(Flexbox.column, Flexbox.fillVertical)}>
          <Scoreboard score={this.state.score} scenario={this.props.scenario} actions={this.state.actions} hideActionButton={true} />
          <ScenarioInfo scenario={this.props.scenario} onComplete={this.handlePlay.bind(this)} />
        </div>
      );
    } else {
      return(
        <div className={css(Flexbox.column, Flexbox.fillVertical)}>
          <Scoreboard score={this.state.score} scenario={this.props.scenario} showTitle actions={this.state.actions} />
          {this.reportToPresent() === 'gameover' &&
            <GameOver score={this.state.score} event={this.state.reportOnEvent} onComplete={this.handleGameOver.bind(this)} />
          }
          {this.reportToPresent() === 'winner' &&
            <Winner effectiveAction={this.state.effectiveAction} event={this.state.reportOnEvent} scenario={this.props.scenario} />
          }
          {this.reportToPresent() === 'event' &&
            <EventReportCard effectiveAction={this.state.effectiveAction} event={this.state.reportOnEvent} onComplete={this.handleReportCardComplete.bind(this)} />
          }
          {this.reportToPresent() === 'none' &&
            <Turn turn={this.state.turn} score={this.state.score} heldActions={this.state.actions} scenario={this.props.scenario} onSpinStart={this.state.turn > 0 && this.handleSpinStart.bind(this)} onTurn={this.handleTurnComplete.bind(this)} />
          }
        </div>
      );
    }
  }

  componentDidUpdate() {
    ScrollFix();
  }

  reportToPresent() {
    if (this.state.score.isGameOver()) {
      return 'gameover';
    } else if (this.isGameWon()) {
      return 'winner';
    } else if (!!this.state.reportOnEvent) {
      return 'event';
    } else {
      return 'none';
    }
  }

  handlePlay() {
    this.setState({pregame: false});
  }

  handleSpinStart() {
    this.setState((prevState) => {
      return {
        score: prevState.score.add(Configuration.passGoReward).normalize(),
        delta: Configuration.passGoReward
      };
    });
  }

  handleTurnComplete(result, obj) {
    if (result === 'action') {
      this.handleAction(obj);
    } else if (result === 'nothing') {
      this.handleDoNothing();
    } else if (result === 'event') {
      this.handleEvent(obj);
    } else if (result === 'wildcard') {
      this.handleWildcard(obj);
    }
  }

  handleAction(action) {
    // Actions present no report, so increment the turn right away
    let delta = action.cost;
    this.setState((prevState) => {
      return {
        actions: prevState.actions.concat([action]),
        turn: prevState.turn + 1,
        score: prevState.score.add(delta).normalize(),
        delta: delta
      };
    });
  }

  handleDoNothing() {
    this.setState((prevState) => {
      return {
        turn: prevState.turn + 1,
      };
    });
  }

  handleEvent(event) {
    let delta = event.impactAdjustedForActions(this.state.actions);
    let effectiveAction = event.mostEffectiveActionFromActions(this.state.actions);
    let eventsHandledDelta = (!!effectiveAction)? 1 : 0;

    // If we have won this level, record it now
    if (this.state.eventsHandled + eventsHandledDelta >= Configuration.requiredEventsToWin) {
      if (this.props.scenario.level !== undefined) {
        Progress.setHighestCompletedLevel(this.props.scenario.level);
        Progress.setBestMoney(this.state.score.add(delta).normalize().c);
      }
    }

    this.setState((prevState) => {
      return({
        reportOnEvent: event,
        effectiveAction: effectiveAction,
        eventsHandled: prevState.eventsHandled + eventsHandledDelta,
        score: prevState.score.add(delta).normalize(),
        delta: delta
      });
    });
  }

  handleWildcard(wildcard) {
    let delta = wildcard.impact;

    this.setState((prevState) => {
      return({
        turn: prevState.turn + 1,
        score: prevState.score.add(delta).normalize(),
        delta: delta
      });
    });
  }

  handleReportCardComplete() {
    this.setState((prevState) => {
      return {
        reportOnEvent: null,
        effectiveAction: null,
        turn: prevState.turn + 1
      };
    });
  }

  handleGameOver() {
    this.setState(this.newGameState());
  }

  newGameState() {
    return {
      pregame: true,
      reportOnEvent: null,
      effectiveAction: null,
      turn: 0,
      score: this.props.initialScore,
      delta: null,
      eventsHandled: 0,
      actions: []
    }
  }

  isGameWon() {
    return this.state.eventsHandled >= Configuration.requiredEventsToWin;
  }
}

export default Game;



// WEBPACK FOOTER //
// ./src/Game.js